import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export const edproSwiperGraduates = () => {
    let swiperGraduates = new Swiper(".js-graduates-slider", {
        modules: [Navigation, Pagination],
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                spaceBetween: 20,
                slidesPerView: "auto",
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
    })
}

export const edproSwiperTeachers = () => {
    let swiperTeachers = new Swiper(".js-teachers-slider", {
        modules: [Navigation, Pagination],
        slidesPerView: 3,
        spaceBetween: 40,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                spaceBetween: 20,
                slidesPerView: "auto",
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },
    })
}
